"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PtBrUsd = exports.PtBrBrr = exports.EnBrUsd = exports.EnBrBrr = void 0;
class EnBrBrr {
    constructor() {
        this.locale = "en-br";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "BRR",
            symbol: "R$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnBrBrr = EnBrBrr;
class EnBrUsd {
    constructor() {
        this.locale = "en-br";
        this.dateFormat = {
            short: "M/d/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, MMMM dd, yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "(Cn)",
        };
    }
}
exports.EnBrUsd = EnBrUsd;
class PtBrBrr {
    constructor() {
        this.locale = "pt-br";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, d' de 'MMMM' de 'yyyy",
        };
        this.currencyFormat = {
            code: "BRR",
            symbol: "R$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.PtBrBrr = PtBrBrr;
class PtBrUsd {
    constructor() {
        this.locale = "pt-br";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "dd MMMM, yyyy",
            long: "dddd, d' de 'MMMM' de 'yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "Cn",
            negativePattern: "(Cn)",
        };
    }
}
exports.PtBrUsd = PtBrUsd;
